(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.CarbonScripts = factory());
})(this, (function () { 'use strict';

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	var _wpcf7_conditionalCountry$1 = {};

	/*
	 * For CF7. Handles the logic of the conditional values in the form,
	 * currently specific to showing States whe "United States" is selected.
	 *
	 * @todo - Remove this file and replace form logic with _wpcf7.conditional-global.js
	 */

	var hasRequired_wpcf7_conditionalCountry;

	function require_wpcf7_conditionalCountry () {
		if (hasRequired_wpcf7_conditionalCountry) return _wpcf7_conditionalCountry$1;
		hasRequired_wpcf7_conditionalCountry = 1;
		(function () {
		    const checkForm = document.querySelector('.wpcf7-form');
		    if (!checkForm) {
		        return;
		    }

		    // make sure that BOTH of the fields have been included
		    const conditionalSelect = document.querySelectorAll(
		        '.conditional__owner .wpcf7-select'
		    );

		    let selection;

		    if (!conditionalSelect) {
		        return;
		    }

		    for (let select of conditionalSelect) {
		        select.addEventListener('change', handleChange, false);
		    }

		    // when the user makes a selection...
		    function handleChange(event) {
		        // get the matching text
		        selection = this.options[this.selectedIndex].text;

		        const conditionalParent = this.parentElement.parentElement; // p.conditional__owner (p > span > select)
		        const conditionalTarget = conditionalParent.nextElementSibling; //p.conditional__target

		        // if the selected country is US, show the state field,
		        // else make sure it stays hidden
		        if (selection === 'United States') {
		            conditionalTarget.classList.remove('hidden-target');
		        } else {
		            if (!conditionalTarget.classList.contains('hidden-target')) {
		                conditionalTarget.classList.add('hidden-target');
		            }
		        }
		    }
		})();

		/*
		EXAMPLE:
		Note that the State isn't *actually* required - no * on the select.
		This is because CF7 creates a list of fields on page load that we can't interact with,
		so although we can could add the correct classes in this script, their call does not validate the field.

		<p class="conditional__owner">
		  <label for="country">Country <span class="req">*</span></label>
		  [select* country id:country include_blank data:countries.olympic]
		</p>

		<p class="conditional__target hidden-target">
		  <label for="state">State <span class="req">*</span></label>
		  <span class="label-details">Providing your state will help us connect you with a local sales rep.</span>
		  [select state id:state include_blank data:us_subdivisions.states data:us_subdivisions.districts]
		</p>

		*/
		return _wpcf7_conditionalCountry$1;
	}

	var _wpcf7_conditionalCountryExports = require_wpcf7_conditionalCountry();
	var _wpcf7_conditionalCountry = /*@__PURE__*/getDefaultExportFromCjs(_wpcf7_conditionalCountryExports);

	return _wpcf7_conditionalCountry;

}));
